import { ChangePhoneModel, OtpVerificationNewNumModel } from "../models/ChangePhoneModel";
import { ResponseModel } from "../models/ResponseModel";
import { UserAuthModel } from "../models/UserAuthModel";
import { AjaxService } from "../shared/services/AjaxService";

const openRequestOptions = {
    includeSessionAuth: false,
    clearSessionOnUnauthorized: false,
};

// models
export interface DevoteeDropdownDto {
    userId: string;
    fullName: string;
    mobileNumber: string;
}

export interface SadhanaTrackerFilterDto {
    fromDate: string;
    toDate: string;
    devotees: string[];
}

export interface CategoryScore {
    type: string;
    score: number;
}

export interface DevoteeScore {
    rank: number;
    fullName: string;
    mobileNo: string;
    totalScore: number;
    category: CategoryScore[];
}

export interface SadhanaTrackerResponse {
    devotees: number;
    avgMarks: number;
    topScore: number;
    devotee: DevoteeScore[];
}

export const UserService = {

    async getLoginConfig(): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>("/User/getForgotPasswordConfig", openRequestOptions);
    },

    async userAuth(payload: UserAuthModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/authenticateUser", payload);
    },

    async userRegistration(payload: UserAuthModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/userRegister", payload);
    },

    async sendOtpByCode(): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/sendOtpByCode", {});
    },

    async removeMyData(otp: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/User/removeMyData?otp=${encodeURIComponent(otp)}`);
    },

    changePhone(payload: ChangePhoneModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/user/changePhone", payload);
    },

    otpVerificationNewNum(payload: OtpVerificationNewNumModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/user/otpVerificationNewNum", payload);
    },

    async getScore(scoreType: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/User/getUserScore?scoreType=${encodeURIComponent(scoreType)}`);
    },

    async getUser(): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/User/getUser`);
    },

    async sendEmailOtp(email: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/User/sendEmailOtp?userEmail=${encodeURIComponent(email)}`);
    },

    async emailVerification(otp: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/User/emailVerification?otp=${encodeURIComponent(otp)}`);
    },

    changeEmail(payload: any): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/user/changeEmail", payload);
    },

    async getDevoteesList(): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>("/User/getDevoteesList");
    },

    async getDevoteesProgress(payload: SadhanaTrackerFilterDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/getDevoteesProgress", payload);
    },
}
